
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Footer from 'components/Footer';
import ResponsiveTopNavigation from 'components/navigation/ResponsiveTopNavigation';
import ServiceModeToggle from 'components/navigation/ServiceModeToggle';
import ContentFilterTabs from 'pages/restaurant-details/components/ContentFilterTabs';
import SearchBar from '../components/SearchBar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { base_url } from 'Backend/api';
import ContentFilterTabs2 from 'pages/market-home-page/components/ContentFilterTabs2';
import SearchBar2 from 'pages/market-home-page/components/SearchBar2';
import NoMarketScreen from 'pages/NoMarketScreen';
import toast from 'react-hot-toast';
import AppSpinner from 'components/ui/AppSpinner';

const resolveImage = (item) =>
  item?.image_url
    ? `${base_url}/${String(item.image_url).replace(/^\/+/, "")}`
    : `${base_url}/storage/app/public/${String(item?.image || "").replace(/^\/+/, "")}`;

const categoryText = (item) =>
  Array.isArray(item?.store_categories) && item.store_categories.length
    ? item.store_categories.map((c) => c?.name).filter(Boolean).join("، ")
    : (item?.type || "");

const PopularMarket = () => {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter') || 'all';
  const category = (searchParams.get('category') || '').trim();
  const latitude = (searchParams.get('latitude') || '').trim();
  const longitude = (searchParams.get('longitude') || '').trim();
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchRestaurants = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          toast.error("يجب تسجيل الدخول أولاً");
          return;
        }
        const endpoint = category
          ? `${base_url}/api/market/categories/${encodeURIComponent(
            category
          )}/markets?nearby[lat]=${encodeURIComponent(latitude)}&nearby[lng]=${encodeURIComponent(
            longitude
          )}`
          : `${base_url}/api/markets?tab=${filter}&search=${search}`;

        const response = await fetch(endpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Accept': 'application/json',
          },
        });

        const data = await response.json();

        if (data.status) {
          setRestaurants(Array.isArray(data.data) ? data.data : []);
        } else {
          setRestaurants([]);
        }
      } catch (error) {
        console.error("خطأ في جلب الماركت:", error);
        setRestaurants([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurants();
  }, [filter, search, category, latitude, longitude]);

  const handleUnfavorite = (id) => {
    setRestaurants(prev =>
      prev.map(r => r.id === id ? { ...r, is_favorite: !r.is_favorite } : r)
    );
  };

  return (
    <>


      <div className="min-h-screen bg-[#f8f8f8] smooth-scroll">
        <ResponsiveTopNavigation />

        <main className="pt-16">
          <div className="flex flex-col lg:flex-row lg:items-center mt-2">
            <div className="lg:w-[30%]">
              <ServiceModeToggle />
            </div>
            <div className="lg:flex-1">
              <SearchBar2 onSearch={setSearch} />
            </div>
          </div>

          <ContentFilterTabs2 />

          <div className="max-w-4xl mx-auto px-4 py-2 font-[cairo]">
            {loading ? (
              <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                <AppSpinner />
              </div>
            ) : restaurants.length === 0 ? (
              <NoMarketScreen compact />
            ) : (
              <>

                <div className="space-y-3 md:space-y-4">
                  {restaurants.map(item => (
                    <div dir='ltr' onClick={() => navigate(`/market/${item.slug || item.id}`)} key={item.id} className="bg-white rounded-[6px] border border-[#ECECEC] overflow-hidden cursor-pointer  p-3">
                      <div className="flex gap-3">
                        <div className="w-[76px] shrink-0 text-[12px]">
                          <div className="inline-flex items-center gap-1 rounded-full bg-[#00B200] px-2 py-0.225 text-white">
                            <span>{item?.rating?.average ?? "0.0"}</span>
                            <span>({item?.rating?.reviews_count ?? item?.rating?.total_count ?? 0})</span>
                            <Icon name="Star" size={11} color="#FFCF33" fill="#FFCF33" />
                          </div>
                          <div className="mt-2 text-[#00A651] flex flex-col items-start gap-1" dir="ltr">
                            <span dir='rtl'>{item?.delivery?.estimate_minutes ?? "—"} دقيقة</span>
                            <div dir='rtl' className="flex items-center gap-1">
                              <img src="/assets/images/bbagg.svg" className="h-3 w-3" alt="" />
                              <span >  {item?.delivered_orders_count ?? 0} طلب </span>
                            </div>
                          </div>

                        </div>

                        <div dir='rtl' className="min-w-55 flex-1">

                          <h3 className="text-[14px] font-medium text-[#1F2937] -mt-1 line-clamp-1 font-[cairo]">{item.name}</h3>
                          <div className="text-[11px] text-[#4B5563] mt-1 line-clamp-1">
                            أقل سعر للطلب {item.minimum_order ?? "—"} ل.س
                          </div>
                          <div className="mt-1 flex items-center  gap-1 text-[10px] text-[#6B7280] line-clamp-1">
                            <Icon name="MapPin" size={13} color="#00B200" />
                            {item.full_address}
                          </div>
                        </div>

                        <div className="relative w-[68px] shrink-0 sm:w-[76px]">
                          <div className="h-[68px] w-[68px] overflow-hidden rounded-[6px] sm:h-[76px] sm:w-[76px]">
                            <Image src={resolveImage(item)} alt={item.name} className="w-full h-full object-cover" />
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUnfavorite(item.id);
                            }}
                            className="absolute -top-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md"
                          >
                            <Icon name="Heart" size={13} color={item.is_favorite ? "#00B200" : "#ccc"} fill={item.is_favorite ? "#00B200" : "none"} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* <Footer /> */}
        </main>
      </div>
    </>
  );
};

export default PopularMarket;